import {FC, useEffect, useState} from 'react';
import SmallBlocks from '@/pages/Organization/Reports/SmallBlocks';
import {Box} from '@mui/material';
import Circulars from './Circulars';
import ReportsTable from './ReportsTable';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getCurrentEventSelector, getEventsLoadingSelector, getEventsSelector} from '@/store/organization-event';
import {getDashboardStatistics} from '@/store/organization-dashboard';
import Loader from '@/shared/components/Loader';
import {dashboardStyle} from '../Dashboard/Dashboard.styles';
import {OrganizationReportsService} from '@/utils/services/organization-reports.service';
import {IOrganizationFullReport} from '@/utils/types/organization-reports.interface';
import EmptyContent from '@/shared/components/Table/EmptyContent';
import {ReactComponent as EmptyCalendarIcon} from '@icons/calendar-empty.svg';


const Reports: FC = () => {
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [statictic, setStatictic] = useState<IOrganizationFullReport | null>(null);

	const dispatch = useAppDispatch();
	const events = useAppSelector(getEventsSelector);
	const currentEvent = useAppSelector(getCurrentEventSelector);
	const isEventsLoading = useAppSelector(getEventsLoadingSelector);

	useEffect(() => {
		if (isEventsLoading) return;

		const fetchDashboardData = async () => {
			setIsDataLoaded(false);

			try {
				await dispatch(getDashboardStatistics(currentEvent!.id)).unwrap();
				const {data} = await OrganizationReportsService.getFullReport({eventId: currentEvent!.id});
				setStatictic(data);
			} catch (error) {
				toast.error(getErrorMessage(error));
			} finally {
				setIsDataLoaded(true);
			}
		};

		if (currentEvent?.id) {
			fetchDashboardData();
		} else if (events && !events.length) {
			setIsDataLoaded(true);
		}
	}, [currentEvent?.id, events?.length, isEventsLoading]);

	useEffect(() => {
		const shouldScrollToReportsTable = sessionStorage.getItem('scrollToReportsTable') === 'true';
		if (!isDataLoaded || !shouldScrollToReportsTable) return;

		const tableElement = document.getElementById('reports-table');
		tableElement?.scrollIntoView({behavior: 'smooth', block: 'start'});
		sessionStorage.removeItem('scrollToReportsTable');
	}, [isDataLoaded]);

	return (
		<Box sx={{position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
			<Box>
				{isDataLoaded ? (!!events?.length && statictic) ? (
					<Box sx={{minHeight: 'calc(100vh - 128px)', display: 'flex', flexDirection: 'column', height: '100%'}}>
						<SmallBlocks statistic={statictic} />
						<Circulars />
						<ReportsTable />
					</Box>
				) : (
					<EmptyContent
								title="There are no events created yet. Create your first event."
								icon={EmptyCalendarIcon}
								parentClassName={dashboardStyle.emptyContent}
							/>
				) : (<Loader parentClassName={dashboardStyle.loader} size={50} />)}
			</Box>
		</Box>
	);
};

export default Reports;
